import { useHotelQuery } from "../../repository/query/use-hotel-query";

type Props = {
	hotelID: string;
};

export const useInitialized = ({ hotelID }: Props) => {
	const { data } = useHotelQuery({ hotelID });

	return {
		data,
	};
};
